module.exports = __webpack_public_path__ + "static/media/starts_with_s.1e159145.mp3";